<div class="image-container"
     [style.background-image]="imageUrl">
</div>
